import { getApiErrorMessage } from "../../../../../utils/commonFunction";
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */

import * as Yup from "yup";

import React, { useState } from "react";

import { Form } from "react-bootstrap";
import SnackBarTool from "../../../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import { StripeSchema } from "../franchise-form/validateSchema";
import { canvaCancel } from "../../../../../utils/canvaCloseFunction";
import { editFranchisePopDetail } from "../../../_redux/franchises/franchisesCrud";
import { useFormik } from "formik";
import { useIntl } from "react-intl";

export function StripeDetail({ detailData }) {
  const intl = useIntl();
  const initialValues = {
    franchise_id: detailData && detailData.id ? detailData.id : "",

    stripe_sk: detailData && detailData.stripe_sk ? detailData.stripe_sk : "",
    stripe_pk: detailData && detailData.stripe_pk ? detailData.stripe_pk : "",
    type: "stripe",
  };

  const [snack, setSnack] = useState({ call: false, type: "", message: "" });

  const handleSubmit = (values, actions) => {
    setSnack({ call: false, type: "", message: "" });
    const data = {
      franchise_id: values.franchise_id,

      stripe_sk: values.stripe_sk,
      stripe_pk: values.stripe_pk,
      type: "stripe",
    };
    editFranchisePopDetail(data)
      .then((res) => {
        "";
        if (res.data.success) {
          setSnack({
            call: true,
            type: "success",
            message: "Stripe detail updated successfully",
          });
          canvaCancel("kt_stripedetail_panel_close");
        } else {
          setSnack({ call: true, type: "error", message: res.data.message });
        }
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
      });
  };

  const handleReset = () => {};

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: StripeSchema(intl, Yup),
    onSubmit: handleSubmit,
    onReset: handleReset,
  });

  return (
    <div
      id="kt_stripedetail_panel"
      className="offcanvas offcanvas-right pt-5 pb-10"
    >
      {/*begin::Header*/}
      <div className="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5">
        <div
          className="offcanvas-close mt-n1 pr-5"
          style={{ position: "absolute", top: "15px", right: "10px" }}
        >
          <span
            onClick={() => formik.resetForm()}
            className="btn btn-xs btn-icon btn-light btn-hover-primary"
            id="kt_stripedetail_panel_close"
          >
            <i className="ki ki-close icon-sm text-muted"></i>
          </span>
        </div>
      </div>
      {/*end::Header*/}
      <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
        <div className="offcanvas-content px-10 ">
          <div>
            <h5>{intl.formatMessage({ id: "Stripe.Details" })}</h5>
          </div>
          <div
            id="kt_quick_panel_logs_kt_stripedetail_panel"
            className="fade pt-3 pr-5 mr-n5 scroll active show ps--active-y mt-10"
          >
            <div className="mt-10 pb-10">
              <div>
                <Form.Group controlId="" className="mb-5">
                  <Form.Label>
                    {intl.formatMessage({ id: "Stripe.Secret.Key" })}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={intl.formatMessage({
                      id: "Stripe.Secret.Key",
                    })}
                    className={`form-control  ${getInputClasses("stripe_sk")}`}
                    name="stripe_sk"
                    {...formik.getFieldProps("stripe_sk")}
                  />
                  {formik.touched.stripe_sk && formik.errors.stripe_sk ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.stripe_sk}
                      </div>
                    </div>
                  ) : null}
                </Form.Group>
              </div>
              <div>
                <Form.Group controlId="" className="mb-5">
                  <Form.Label>
                    {intl.formatMessage({ id: "Stripe.Public.Key" })}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder={intl.formatMessage({
                      id: "Stripe.Public.Key",
                    })}
                    className={`form-control  ${getInputClasses("stripe_pk")}`}
                    name="stripe_pk"
                    {...formik.getFieldProps("stripe_pk")}
                  />
                  {formik.touched.stripe_pk && formik.errors.stripe_pk ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.stripe_pk}
                      </div>
                    </div>
                  ) : null}
                </Form.Group>
              </div>
            </div>
          </div>
        </div>
        <div className="offcanvas-footer">
          <div className="offcanvas-content text-right ">
            <button
              type="reset"
              className="btn btn-dark font-weight-bolder font-size-sm mr-3 "
              onClick={() => canvaCancel("kt_stripedetail_panel_close")}
            >
              {intl.formatMessage({ id: "CANCEL" })}
            </button>
            <button
              type="submit"
              className="btn btn-primary font-weight-bolder font-size-sm mr-3 "
            >
              {intl.formatMessage({ id: "SAVE" })}
            </button>
          </div>
        </div>
      </form>
      {snack.call ? <SnackBarTool {...snack} /> : ""}
    </div>
  );
}
